module.exports = __webpack_public_path__ + "img/calendarEvent.51f5634f.svg";